








































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
class CollapsibleItem extends Vue {
  @Prop({ type: String }) label
  collapsed = true

  toggle() {
    this.collapsed = !this.collapsed
  }

  @Emit('delete')
  onDelete() {}
}

export default CollapsibleItem
